var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDelete(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 13,
    height: 16,
    viewBox: "0 0 13 16",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "delete",
    d: "M18.575,9.037l-.273,7.8a2.656,2.656,0,0,1-2.73,2.485H10.384a2.656,2.656,0,0,1-2.73-2.482l-.273-7.8a.684.684,0,0,1,1.365-.043l.273,7.8a1.332,1.332,0,0,0,1.365,1.239h5.188a1.332,1.332,0,0,0,1.365-1.241l.273-7.8a.684.684,0,0,1,1.365.043Zm.9-2.6a.664.664,0,0,1-.683.644H7.161a.645.645,0,1,1,0-1.289H9.277a.854.854,0,0,0,.869-.74,2,2,0,0,1,2.037-1.736h1.59A2,2,0,0,1,15.81,5.058a.854.854,0,0,0,.869.74h2.116a.664.664,0,0,1,.683.644ZM11.331,5.8h3.3a2.033,2.033,0,0,1-.174-.608.669.669,0,0,0-.678-.58h-1.59a.669.669,0,0,0-.678.58,2.033,2.033,0,0,1-.175.608Zm.687,9.761V10.072a.684.684,0,0,0-1.365,0v5.488a.684.684,0,0,0,1.365,0Zm3.286,0V10.072a.684.684,0,0,0-1.365,0v5.488a.684.684,0,0,0,1.365,0Z",
    transform: "translate(-6.478 -3.322)",
    fill: "#df0000"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDelete);
export default __webpack_public_path__ + "static/media/delete.dbbf7316f369e8d25f5f3b0ebd2d9c2f.svg";
export { ForwardRef as ReactComponent };